"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORNER_RADIUS_UNITS_VALUES = exports.ANIMATIONS_EASINGS_MAP = exports.ANIMATION_AVAILABLE_EASINGS = exports.FIRST_TIMER_PROPERTIES = exports.ANIMATION_INTENSITY_TYPES = exports.ANIMATION_MOTION_SMOOTHING_TYPES = exports.VOICEOVER_TYPES_LABELS = exports.VOICEOVER_CONFIG_TYPES = exports.VOICEOVER_CONFIG = exports.AUDIO_TYPES = exports.VOICEOVER_TYPES = exports.GENERATING_THUMB_URL = exports.MISSING_MEDIA_URL = exports.VIDEO_PLACEHOLDER_URL = exports.IMAGE_PLACEHOLDER_URL = exports.EMBED_CONTENT_TYPES = exports.PROPERTY_INPUT_TYPES = exports.AVAILABLE_CANVAS_SIZES = exports.VIDEO_READY_STATE = exports.DISPLAY_MODE = exports.USER_MEDIA_TYPES_STR = exports.USER_MEDIA_TYPES = exports.CONTENT_TYPE = exports.MEDIA_ORIGINS = exports.MEDIA_TYPES_BY_FILE_TYPE = exports.MEDIA_TYPES = exports.SUB_MENUS = exports.FILE_TYPE_NEW_FORMAT = exports.FILE_TYPE = exports.SHAPE_ATTRIBUTE = exports.BRAND_TEXT_TYPES = exports.TABS = exports.ELEMENT_SHAPE_TYPE = exports.ELEMENT_BACKGROUND_TYPE = exports.ELEMENT_ANIMATION_STYLE = exports.TEXT_ELEMENT_STYLE = exports.ELEMENT_STYLE = exports.ELEMENT_TYPE = void 0;
exports.ELEMENT_TYPE = {
    SHAPE: 'adstudio-element-shape',
    IMAGE: 'adstudio-element-image',
    VIDEO: 'adstudio-element-video',
    TEXT: 'adstudio-element-text',
    BACKGROUND: 'adstudio-element-background',
    VIDEOBACKGROUND: 'adstudio-element-video-background',
    AUDIO: 'adstudio-element-audio',
};
exports.ELEMENT_STYLE = {
    CORNER_RADIUS: 'cornerRadius',
    CORNER_RADIUS_UNIT: 'cornerRadiusUnit',
    SHAPE_TYPE: 'shapeType',
    OPACITY: 'opacity',
    SHADOW: 'shadow',
    BACKGROUND: 'background',
    OUTLINE: 'outline',
    X: 'x',
    Y: 'y',
    WIDTH: 'width',
    HEIGHT: 'height',
    ZINDEX: 'z',
    LOCK: 'lock',
    VISIBLE: 'visible',
    ANGLE: 'angle',
    ANIMATION: 'animation',
    ANIMATIONS_TIMELINE: 'animationsTimeline',
    EXTERNAL_LINK: 'externalLink',
};
exports.TEXT_ELEMENT_STYLE = {
    LINE_HEIGHT: 'lineHeight',
    FONT_SIZE: 'fontSize',
    LETTER_SPACING: 'letterSpacing',
    FONT_STYLE: 'fontStyle',
    FONT_FAMILY: 'fontFamily',
    TEXT_DECORATION: 'textDecoration',
    FONT_WEIGHT: 'fontWeight',
    ALIGNMENT: 'alignment',
    COLOR: 'color',
};
exports.ELEMENT_ANIMATION_STYLE = {
    EFFECT: 'effect',
    DIRECTION: 'direction',
    DELAY: 'delay',
    DURATION: 'duration',
    TIMING_FUNCTION: 'timingFunction',
    ANIME_CONFIG: 'animeConfig',
    MOTION_SMOOTHING: 'motionSmoothing',
    INTENSITY: 'intensity',
};
exports.ELEMENT_BACKGROUND_TYPE = {
    COLOR: 'adstudio-background-color',
    IMAGE: 'adstudio-background-image',
    GRADIENT: 'adstudio-background-gradient',
    VIDEO: 'adstudio-background-video',
};
exports.ELEMENT_SHAPE_TYPE = {
    RECTANGLE: 'rectangle',
    CIRCLE: 'circle',
};
exports.TABS = {
    EDIT: 'edit',
    BIP: 'bip',
    DATA: 'data',
    CANVAS: 'canvas',
    LAYERS: 'layers',
    MUSIC: 'music',
    SETTINGS: 'settings',
};
exports.BRAND_TEXT_TYPES = {
    HEADER: {
        type: 'H1',
        name: 'Headlines',
        key: 'headingFontId',
    },
    SUB_HEADER: {
        type: 'H2',
        name: 'SubHeadlines',
        key: 'subHeadingFontId',
    },
    BODY: {
        type: 'H3',
        name: 'Body Copy',
        key: 'bodyFontId',
    },
    FOOTER: {
        type: 'H4',
        name: 'Footer/Disclosure',
        key: 'footerFontId',
    },
};
exports.SHAPE_ATTRIBUTE = {};
exports.FILE_TYPE = {
    IMAGE: '0',
    VIDEO: '1',
    AUDIO: '2',
};
exports.FILE_TYPE_NEW_FORMAT = {
    '0': 'image',
    '1': 'video',
    '2': 'audio',
};
exports.SUB_MENUS = {
    MEDIA: 'adstudio-sub-menu-media',
    DYNAMIC_IMAGES: 'adstudio-sub-menu-dynamic-images',
    SCENE_TRANSITIONS: 'adstudio-sub-menu-scene-transitions',
    SCENE_LAYOUTS: 'adstudio-sub-scene-layouts',
};
exports.MEDIA_TYPES = {
    STOCK_AUDIO: 'stockAudio',
    STOCK_IMAGES: 'stockImages',
    STOCK_VIDEOS: 'stockVideos',
    PEXELS: 'pexels',
    PEXELS_VIDEOS: 'pexelsVideos',
    THIRD_PARTY_AUDIO: 'thirdPartyAudio',
    CURRENT_PAGE: 'currentPage',
    CURRENT_STOCK_PAGE: 'currentStockPage',
    QUERY: 'query',
    ELEMENT: 'elementToReplace',
    MEDIA_TO_UPLOAD: 'mediaToUpload',
    LAST_TYPE_UPDATED: 'lastTypeUpdates',
    ACTIVE_TAB: 'activeTab',
};
exports.MEDIA_TYPES_BY_FILE_TYPE = {
    [exports.FILE_TYPE.IMAGE]: exports.MEDIA_TYPES.STOCK_IMAGES,
    [exports.FILE_TYPE.VIDEO]: exports.MEDIA_TYPES.STOCK_VIDEOS,
    [exports.FILE_TYPE.AUDIO]: exports.MEDIA_TYPES.STOCK_AUDIO,
};
exports.MEDIA_ORIGINS = {
    COMPANY_VAULT: 'COMPANY_VAULT',
    THIRD_PARTY: 'THIRD_PARTY',
    UPLOAD: 'UPLOAD',
};
exports.CONTENT_TYPE = {
    CHAPTER: 'chapter',
    SCENE_LAYOUT: 'sceneLayout',
};
exports.USER_MEDIA_TYPES = {
    IMAGE: 0,
    VIDEO: 1,
    AUDIO: 2,
};
exports.USER_MEDIA_TYPES_STR = {
    0: 'image',
    1: 'video',
    2: 'audio',
};
exports.DISPLAY_MODE = {
    DISPLAY: 1,
    LAPTOP: 2,
    TABLET: 3,
    MOBILE: 4,
};
exports.VIDEO_READY_STATE = {
    HAVE_NOTHING: 0,
    HAVE_METADATA: 1,
    HAVE_CURRENT_DATA: 2,
    HAVE_FUTURE_DATA: 3,
    HAVE_ENOUGH_DATA: 4,
};
exports.AVAILABLE_CANVAS_SIZES = [
    {
        ratio: '16:9',
        sizes: [
            {
                name: 'FULL HD',
                width: 1920,
                height: 1080,
                style: 'width:90px;height:50px',
            },
            {
                name: 'YOUTUBE',
                width: 1280,
                height: 720,
                style: 'width:90px;height:50px',
            },
        ],
    },
    {
        ratio: '4:3',
        sizes: [
            {
                name: 'HIGH RES',
                width: 1080,
                height: 768,
                style: 'width:60px;height:45px',
            },
            {
                name: 'WEB RES',
                width: 640,
                height: 480,
                style: 'width:60px;height:45px',
            },
        ],
    },
    {
        ratio: '1:1',
        sizes: [
            {
                name: 'LARGE',
                width: 800,
                height: 800,
                style: 'width:50px;height:50px',
            },
            {
                name: 'MEDIUM',
                width: 400,
                height: 400,
                style: 'width:50px;height:50px',
            },
            {
                name: 'SMALL',
                width: 200,
                height: 200,
                style: 'width:50px;height:50px',
            },
        ],
    },
    {
        ratio: 'WEB ADS',
        sizes: [
            {
                name: 'BANNER',
                width: 728,
                height: 90,
                style: 'width:120px;height:30px',
            },
            {
                name: 'HALF PAGE',
                width: 600,
                height: 300,
                style: 'width:120px;height:60px',
            },
            {
                name: 'INLINE',
                width: 300,
                height: 250,
                style: 'width:60px;height:60px',
            },
        ],
    },
];
exports.PROPERTY_INPUT_TYPES = {
    NUMBERS: 'numbers',
    POSITIVE_NUMBERS: 'positive_numbers',
    NEGATIVE_NUMBERS: 'negative_numbers',
};
exports.EMBED_CONTENT_TYPES = {
    CHAPTER: 'chapter',
    PLAYER: 'player',
    IFRAME: 'iframe',
};
exports.IMAGE_PLACEHOLDER_URL = '/images/image_placeholder.svg';
exports.VIDEO_PLACEHOLDER_URL = '/images/video_placeholder.jpg';
exports.MISSING_MEDIA_URL = '/images/missing_media.png';
exports.GENERATING_THUMB_URL = '/images/generating_thumb.png';
exports.VOICEOVER_TYPES = {
    CUSTOM_UPLOAD: 0,
    USER_RECORDED: 1,
    TEXT_TO_SPEECH: 2,
};
exports.AUDIO_TYPES = {
    CHAPTER_AUDIO: 'chapter-audio',
    SCENE_VOICE_OVER: 'scene-voiceover',
    CHAPTER_VOICE_OVER: 'chapter-voiceover',
};
exports.VOICEOVER_CONFIG = {
    IS_CHAPTER_VOICEOVER: 'isChapterVoiceover',
    SCENE_VOICEOVER_INDEX: 'sceneVoiceOverIndex',
};
exports.VOICEOVER_CONFIG_TYPES = {
    CHAPTER_VOICEOVER: 'chapter-voice-over',
    SCENE_VOICEOVER: 'scene-voice-over',
};
exports.VOICEOVER_TYPES_LABELS = {
    0: 'Custom Audio Upload',
    1: 'Mic Recording',
    2: 'AI-Assisted Voiceover (Text to speech)',
};
exports.ANIMATION_MOTION_SMOOTHING_TYPES = {
    IN_OUT: 'IN_OUT',
    IN: 'IN',
    OUT: 'OUT',
    LINEAR: 'LINEAR',
};
exports.ANIMATION_INTENSITY_TYPES = {
    LIGHT: 'LIGHT',
    MEDIUM: 'MEDIUM',
    STRONG: 'STRONG',
};
exports.FIRST_TIMER_PROPERTIES = {
    SCENE_LAYOUTS: 'sceneLayouts',
};
exports.ANIMATION_AVAILABLE_EASINGS = {
    EASE_IN_QUAD: 'easeInQuad',
    EASE_IN_QUART: 'easeInQuart',
    EASE_IN_EXPO: 'easeInExpo',
    EASE_OUT_QUAD: 'easeOutQuad',
    EASE_OUT_QUART: 'easeOutQuart',
    EASE_OUT_EXPO: 'easeOutExpo',
    EASE_IN_OUT_QUAD: 'easeInOutQuad',
    EASE_IN_OUT_QUART: 'easeInOutQuart',
    EASE_IN_OUT_EXPO: 'easeInOutExpo',
    LINEAR: 'linear',
};
exports.ANIMATIONS_EASINGS_MAP = {
    [exports.ANIMATION_MOTION_SMOOTHING_TYPES.IN]: {
        [exports.ANIMATION_INTENSITY_TYPES.LIGHT]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_QUAD,
        [exports.ANIMATION_INTENSITY_TYPES.MEDIUM]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_QUART,
        [exports.ANIMATION_INTENSITY_TYPES.STRONG]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_EXPO,
    },
    [exports.ANIMATION_MOTION_SMOOTHING_TYPES.OUT]: {
        [exports.ANIMATION_INTENSITY_TYPES.LIGHT]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_OUT_QUAD,
        [exports.ANIMATION_INTENSITY_TYPES.MEDIUM]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_OUT_QUART,
        [exports.ANIMATION_INTENSITY_TYPES.STRONG]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_OUT_EXPO,
    },
    [exports.ANIMATION_MOTION_SMOOTHING_TYPES.IN_OUT]: {
        [exports.ANIMATION_INTENSITY_TYPES.LIGHT]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_OUT_QUAD,
        [exports.ANIMATION_INTENSITY_TYPES.MEDIUM]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_OUT_QUART,
        [exports.ANIMATION_INTENSITY_TYPES.STRONG]: exports.ANIMATION_AVAILABLE_EASINGS.EASE_IN_OUT_EXPO,
    },
    [exports.ANIMATION_MOTION_SMOOTHING_TYPES.LINEAR]: {
        [exports.ANIMATION_INTENSITY_TYPES.LIGHT]: exports.ANIMATION_AVAILABLE_EASINGS.LINEAR,
        [exports.ANIMATION_INTENSITY_TYPES.MEDIUM]: exports.ANIMATION_AVAILABLE_EASINGS.LINEAR,
        [exports.ANIMATION_INTENSITY_TYPES.STRONG]: exports.ANIMATION_AVAILABLE_EASINGS.LINEAR,
    },
};
exports.CORNER_RADIUS_UNITS_VALUES = {
    PERCENTAGE: '%',
    PIXELS: 'px',
};
